import React from 'react';
import '../styles/HowItWorks.css';

const HowItWorks: React.FC = () => {
  return (
    <div className="how-it-works-container">
      <h1>Claim your Game!</h1>
      <p className="top-text">
        Are you the developer of a game that's listed on Weirdly.fuN? Claim It!
      </p>

      <div className="no-statements">
        <p><span className="no">How do I do that?</span></p>
      </div>

      <div className="steps-diagram">
        <svg viewBox="0 0 1000 200" className="steps-svg">
          <path d="M100,120 Q250,30 400,100 T700,90 T900,120" className="path" />
          <circle cx="100" cy="100" r="50" className="step-circle active" />
          <circle cx="300" cy="100" r="50" className="step-circle" />
          <circle cx="500" cy="100" r="50" className="step-circle active" />
          <circle cx="700" cy="100" r="50" className="step-circle" />
          <circle cx="900" cy="100" r="50" className="step-circle active" />
          <text x="100" y="105" className="step-number">I</text>
          <text x="300" y="105" className="step-number">II</text>
          <text x="500" y="105" className="step-number">III</text>
          <text x="700" y="105" className="step-number">IV</text>
          <text x="900" y="105" className="step-number">V</text>
        </svg>
      </div>

      <div className="steps-description">
        <div className="step">
          <p className="step-title">Step 1</p>
          <p>Search for your game on Weirdly.fuN. Click "share" and copy url.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 2</p>
          <p>Go to the official Weirdly.fuN Twitter (X) account. <a href={"https://x.com/WeirdlyFunApp"}>(@WeirdlyFunApp)</a></p>
        </div>
        <div className="step">
          <p className="step-title">Step 3</p>
          <p>Create a tweet that says "claiming my game". Include the share link and mention Weirdly.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 4</p>
          <p>Pump your tweet until it receives at least 10 likes. Make sure you follow us.</p>
        </div>
        <div className="step">
          <p className="step-title">Step 5</p>
          <p>If the game does exist on Weirdly, we'll DM you on Twitter (X) within 48hrs.</p>
        </div>
      </div>

      <div className="buttons-container">
        <p>
          To speed-up the claim process, try to have another team member from the project retweet and like your tweet.
        </p>
      </div>
    </div>
  );
};

export default HowItWorks;